import headerImgEn from "assets/images/v9-nd-pb/header-en.webp"
import infoImgEn from "assets/images/v9-nd-pb/info-en.webp"

export const v9ndpbConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
